import React, {PropTypes as T} from 'react';
import cx from "classnames";
import { Button, Icon, VirtualBody } from '../';
import './dialogs.less';

export default class Dialog extends React.Component {
    static propTypes = {
        actionButton: T.element,
        title: T.string.isRequired,
        onCancel: T.func,
        showHeader: T.bool,
        disablePrimaryAction: T.bool,
        showFooter: T.bool,
        canCancelByClickingOutside: T.bool,
        cancelButtonText: T.string,
    };

    static defaultProps = {
        onCancel: () => {},
        onPrimaryAction: () => {},
        showHeader : true,
        showCancelButton : true,
        showActionButton : true,
        stayOpenOnBodyClick: true,
        actionButtonText : 'Ok',
        actionButtonType : 'primary',
        disablePrimaryAction: false,
        showFooter: true,
        canCancelByClickingOutside: true,
        cancelButtonText: 'Cancel',
    };

    constructor(props) {
        super(props);

        this.state = {
            mounted: false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ mounted: true });
        }, 50);
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    handleOnCancel(e) {
        if(this.props.onCancel) {
            this.props.onCancel();    
        }
    }

    handleOnPrimaryAction(e) {
        if(this.props.onPrimaryAction) {
            this.props.onPrimaryAction();
        }
    }

    handleClickBackground(e) {

        if (!this.props.canCancelByClickingOutside) {
            return;
        }

        this.props.onCancel();
        e.stopPropagation();
        e.preventDefault();
    }
    
    handleMouseUp(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    render() {
        var classNames = "dialog" + (this.state.mounted ? " slide" : "");
        var { children, showCancelButton, showActionButton, showHeader, actionButtonText, actionButtonType, customButtons, showFooter, cancelButtonText } = this.props;

        return (
            <div className="dialog-container" onMouseUp={this.handleClickBackground.bind(this)}>
                <div className={classNames} onMouseUp={this.handleMouseUp.bind(this)}>
                    <div className="dialog-content">
                        <VirtualBody>
                        

                        { showHeader && 
                            <div className="dialog-header">
                                <div className="title">{this.props.title}</div>
                                <div className="close" onClick={this.props.onCancel.bind(this)}><Icon icon="delete-1-1" size={14} /></div>
                            </div>
                        }

                        <div className={cx("dialog-body", { "header-not-shown": !showHeader }, { "footer-not-shown": !showFooter })}>
                            { children }
                        </div>

                        { showFooter && customButtons && 
                            <div className="dialog-footer">
                                { customButtons() }
                            </div>
                        }

                        { showFooter && !customButtons && 
                            <div className="dialog-footer">
                                <div style={{flex: 1}}></div>
                                
                                { showCancelButton && 
                                    <Button onClick={this.handleOnCancel.bind(this)} type="default">{ cancelButtonText }</Button>
                                }

                                { showActionButton && 
                                    <Button disabled={this.props.disablePrimaryAction} onClick={this.handleOnPrimaryAction.bind(this)} type={actionButtonType}>{actionButtonText}</Button>
                                }           
                            </div>
                        }

                        </VirtualBody>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/dialogs/Dialog.js